import styled from 'styled-components';

export const AppContainer = styled.div`
  height: 100vh;
  text-align: center;
  display: flex;
  flex-direction: column;
`;